export default "__VITE_ASSET__BAY6BPeL__"